const DropdownWhiteIcon = (props:any) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 16 8">
      <path
        id="Polygon_8"
        data-name="Polygon 8"
        d="M8,0l8,8H0Z"
        transform="translate(16 8) rotate(180)"
        fill="#fff"
      />
    </svg>
  );
};
export default DropdownWhiteIcon;
